import { render, staticRenderFns } from "./camera_info.vue?vue&type=template&id=2f3d3389&scoped=true&"
import script from "./camera_info.vue?vue&type=script&lang=js&"
export * from "./camera_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d3389",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3d3389')) {
      api.createRecord('2f3d3389', component.options)
    } else {
      api.reload('2f3d3389', component.options)
    }
    module.hot.accept("./camera_info.vue?vue&type=template&id=2f3d3389&scoped=true&", function () {
      api.rerender('2f3d3389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/cameras/tabs/camera_info.vue"
export default component.exports